<template>
  <div>
    <div
      v-bind:class="[{ 'home-banner': homeHeader && !searchbarVisible && !sharePreview && getLangLoadStatus },{'sticky': homeHeader && searchbarVisible}, {'sticky': !homeHeader}, 'navbar']">
      <nav class="uk-navbar-container" id="navBar" uk-navbar v-bind:class="navbarClass">
        <div class="uk-grid-collapse" uk-grid>
          <div class="uk-navbar-item">
            <div class="uk-position-left add-pointer">
              <div class="logo-img-custom" id="SmartLogo">
                <div v-if="isShareResource || !this.shareButton" @click="home">
                  <smex-logo :isMobileLogo="isMobileLogo"></smex-logo>
                </div>
                <router-link v-else :to="{name: route_Home_Name}">
                  <smex-logo :isMobileLogo="isMobileLogo"></smex-logo>
                </router-link>
              </div>
            </div>
            <div class="uk-visible@m search-bar-custom uk-position-left" v-if="searchbarVisible">
              <SearchBar class="search-width"></SearchBar>
            </div>
            <div style="z-index: 3;" v-bind:class="[{ 'home-header-top': !searchbarVisible }, 'uk-width-1-6']"
                 v-if="!sharePreview">
              <user-profile :homeHeader="!searchbarVisible"
                            :shareButton="shareButton"
                            :userProfile="getUserProfile"
                            class="user-profile uk-position-right"
                            to="Profile"></user-profile>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="uk-hidden@m mobile-navbar-custom-height" v-if="searchbarVisible">
      <SearchBar></SearchBar>
    </div>
    <actions-bar :mod="moderation" v-if="resourcePreview"></actions-bar>
    <div v-if="homeHeader && getLangLoadStatus">
      <HomeSearchBar @searchBarVisible="isSearchBarVisible" class="home-header"></HomeSearchBar>
    </div>
    <leave-page-modal
      :id="leaveNavigationBar"
      @leave-page="leavePage">
    </leave-page-modal>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from 'vuex'
  import UserProfile from '../profile/user-profile'
  import HomeSearchBar from './home-search-bar'
  import SearchBar from './search-bar'
  import Router from '../../router'
  import Environment from '../../plugins/environment'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'
  import * as routes from '../../enums/routes'
  import ActionsBar from '../resources/manage-resources/actions-bar/actions-bar'
  import leavePageModal from '../ui-components/modals/leave-page'
  import UIkit from 'uikit'
  import screenUtil from '../../utils/screen-util'
  import SmexLogo from './smex-logo'
  import { SLSO } from '../../enums/clients'

  export default {
    name: 'Header',
    components: {
      UserProfile,
      HomeSearchBar,
      SearchBar,
      ActionsBar,
      leavePageModal,
      SmexLogo
    },
    data() {
      return {
        homeHeader: window.location.pathname === '/',
        navbar: 'navbar',
        transparent: 'uk-navbar-transparent',
        navbarClass: 'uk-navbar-transparent',
        searchbarVisible: false,
        sharePreview: false,
        smexLogo: iconUtil.resolve(misc.SMEX_LOGO),
        smexMobileLogo: iconUtil.resolve(misc.SMEX_MOBILE_LOGO),
        slsoLogo: iconUtil.resolve(misc.SLSO_LOGO),
        route_Share: routes.ROUTE_NAME_SHARE,
        route_Search: routes.ROUTE_NAME_SEARCH,
        route_MyResource: routes.ROUTE_NAME_MYRESOURCE,
        route_ModerateResource: routes.ROUTE_NAME_MODERATE_RESOURCE,
        route_ModerateResources: routes.ROUTE_NAME_MODERATE_RESOURCES,
        route_ModerateResourcesWithStatus: routes.ROUTE_NAME_MODERATE_RESOURCES_STATUS,
        route_Home_Name: routes.ROUTE_NAME_HOME,
        resourcePreview: false,
        resourceStatus: '',
        leaveNavigationBar: 'leave-navigation-bar',
        moderation: false,
        shareButton: true,
        screenWidth: 0,
        isMobileLogo: false,
        iconInfo: iconUtil.resolve(misc.ICON_INFO)
      }
    },
    watch: {
      $route: function (value) {
        // Control the Nav when the route changes
        this.homeHeader = window.location.pathname === '/'
        this.renderNav(value)
      },
      homeHeader() {
        if (!this.homeHeader) {
          this.navbarClass = this.navbar
          this.searchbarVisible = true
        }
      },
      screenWidth(newVal) {
        this.isMobileLogo = newVal < 1024
      },
      getLangLoadStatus() {
        if (this.getLangLoadStatus) {
          this.resourcePreview = false
          this.shareButton = true
          this.navbarClass = this.navbar
          this.searchbarVisible = true
        }
      }
    },
    computed: {
      ...mapGetters(['getUserProfile', 'getResourceDataAdded', 'getLangLoadStatus']),
      isShareResource() {
        return this.$route.path === routes.SHARE_RESOURCE
      },
      suiteUrl() {
        return Environment.serviceUrlFor(SLSO)
      }
    },
    methods: {
      ...mapMutations(['setResourceDataAdded']),
      resolveWindowWidth() {
        this.screenWidth = screenUtil.resolveWidth()
        this.isMobileLogo = this.screenWidth < 1024
      },
      home() {
        if (this.isShareResource) {
          if (this.getResourceDataAdded) {
            UIkit.modal('#leave-navigation-bar').show()
          } else {
            Router.push({name: routes.ROUTE_NAME_HOME})
          }
        } else if (!this.shareButton) {
          return ''
        }
      },
      leavePage() {
        this.setResourceDataAdded(false)
        setTimeout(() => {
          Router.push({name: routes.ROUTE_NAME_HOME})
        }, 500)
      },
      isSearchBarVisible(visibility) {
        this.toggleNavbarClass(visibility)
        this.showSearchbar(visibility)
      },
      toggleNavbarClass(searchBarVisible) {
        if (this.homeHeader) {
          if (searchBarVisible) {
            this.navbarClass = this.transparent
          } else {
            this.navbarClass = this.navbar
          }
        } else {
          this.navbarClass = this.navbar
        }
      },
      showSearchbar(searchBarVisible) {
        if (!this.homeHeader) {
          this.searchbarVisible = true
        } else {
          if (!searchBarVisible) {
            this.searchbarVisible = true
          } else {
            this.searchbarVisible = false
          }
        }
      },
      renderNav(value) {
        switch (value.name) {
          case this.route_Share:
            this.sharePreview = true
            this.searchbarVisible = false
            this.resourcePreview = false
            this.shareButton = false
            break
          case this.route_Search:
            this.sharePreview = false
            this.resourcePreview = false
            this.isSearchBarVisible(true)
            break
          case this.route_MyResource:
            this.resourcePreview = true
            this.isSearchBarVisible(true)
            this.moderation = false
            break
          case this.route_ModerateResource:
            this.resourcePreview = true
            this.searchbarVisible = true
            this.moderation = true
            this.shareButton = false
            break
          case this.route_ModerateResources:
            this.searchbarVisible = true
            this.resourcePreview = false
            this.shareButton = false
            this.moderation = false
            break
          case this.route_ModerateResourcesWithStatus:
            this.searchbarVisible = false
            this.resourcePreview = false
            this.shareButton = false
            this.moderation = false
            break
          default:
            this.resourcePreview = false
            this.shareButton = true
            this.moderation = false
            break
        }
      },
      initNavBar(value) {
        switch (value) {
          case this.route_Share:
            this.sharePreview = true
            break
          case this.route_MyResource:
            this.resourcePreview = true
            break
          case this.route_ModerateResources:
            this.searchbarVisible = true
            this.shareButton = false
            break
          case this.route_ModerateResourcesWithStatus:
            this.searchbarVisible = true
            this.shareButton = false
            this.moderation = false
            break
          case this.route_ModerateResource:
            this.shareButton = false
            this.moderation = true
            this.resourcePreview = true
            this.searchbarVisible = true
            break
          default:
            this.isSearchBarVisible(true)
            this.moderation = false
            this.resourcePreview = false
            this.shareButton = true
        }
      }
    },
    created() {
      if (!this.homeHeader) {
        this.navbarClass = this.navbar
        this.initNavBar(this.$route.name)
      }
      this.resolveWindowWidth()
      window
        .addEventListener(
          'resize',
          this.resolveWindowWidth)
    },
    destroyed() {
      window
        .removeEventListener(
          'resize',
          this.resolveWindowWidth)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  .info-icon {
    z-index: 5;
    margin-right: 3px;
    margin-top: 5px;
  }

  .pink{
    background-color: hotpink !important;
  }

  .home-banner {
    top: 10px;
    position: absolute;
  }

  .text-underline {
    color: white;
    text-decoration: underline;
    text-decoration-color: white;
  }

  .sticky {
    position: fixed;
  }

  .navbar {
    width: 100%;
    z-index: 3;
  }

  .home-header {
    padding-top: 56px;
  }

  nav.uk-navbar-container.uk-navbar-transparent {
    height: 56px;
  }

  nav.uk-navbar-container.navbar {
    background-color: $light-blue;
    height: 56px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
  }

  .search-width {
    width: 462px;
  }

  .search-bar-custom {
    margin-left: 238px;
    height: 56px;
  }

  .user-profile {
    padding-top: 15px;
    padding-right: 50px;
    height: 56px;
  }

  .mobile-navbar-custom-height {
    width: 100%;
    padding-top: 48px;
    z-index: 1;
    position: fixed;
    top: 0;
  }

  .logo-img-custom {
    width: 200px !important;
    height: 22px !important;
    margin-left: 24px;
    margin-top: 17px;
    margin-right: 14px;
    &#SLSOLogo {
      margin-top: 12px;
    }
  }

  .uk-first-column {
    height: 56px;
  }

  .uk-navbar-item {
    min-height: 56px;
  }

  .triangle {
    border-right: 50px solid $purple;
    border-bottom: 50px solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .triangle-text {
    color: white;
    transform: rotate(45deg);
    font-size: 12px;
    margin-top: 3px;
    margin-left: 25px;
  }

  .home-header-top {
    top: 36px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    nav.uk-navbar-container.navbar {
      height: 48px;
    }
    nav.uk-navbar-container.uk-navbar-transparent {
      height: 48px;
    }
    .user-profile {
      padding-top: 9px;
      padding-right: 50px;
      height: 48px;
    }
    .search-bar-custom {
      height: 48px;
    }
    .logo-img-custom {
      margin-top: 12px;
      &#SLSOLogo {
        margin-top: 9px;
      }
    }
    .uk-first-column {
      height: 48px;
    }
    .uk-navbar-item {
      min-height: 48px;
    }

    .triangle {
      border-right: 48px solid $purple;
      border-bottom: 48px solid transparent;
    }

    .triangle-text {
      margin-left: 20px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .user-profile {
      padding-top: 10px;
      height: 33px;
      padding-right: 48px;
    }
    .logo-img-custom {
      width: 140px !important;
      margin-left: 16px;
      margin-top: 17px;
    }
  }
</style>
